import Home from '../view/homeComponent.vue'
export const  route = [
    {
        path:'/',
        component:Home,
        redirect: '/index',
        children: [
            {
                path: 'index',
                name: 'index',
                meta: { title: '首页' },
                component: () => import('../view/indexComponrnt.vue')
            },
            {
                path: 'Department',
                name: 'Department',
                meta: { title: '科室介绍' },
                component: () => import('../view/DepartmentComponent.vue')
            },
            {
                path: 'authority',
                name: 'authority',
                meta: { title: '专家介绍' },
                component: () => import('../view/authorityComponent.vue')
            },
            {
                path: 'introdoctor',
                name: 'introdoctor',
                meta: { title: '细节介绍' },
                component: () => import('../view/introdoctorComponent.vue')
            },
            {
                path: 'QualityControl',
                name: 'QualityControl',
                meta: { title: '质控专题' },
                component: () => import('../view/QualityControl.vue')
            },
            {
                path: 'learningCompontent',
                name: 'learningCompontent',
                meta: { title: '学术培训' },
                component: () => import('../view/learningCompontent.vue')
            },
            {
                path:'conference',
                name: 'conference',
                meta: { title: '会议通知' },
                component: () => import('../view/conferenceCompontent.vue')
            },
            {
                path:'popularizationScience',
                name: 'popularizationScience',
                meta: { title: '会议通知' },
                component: () => import('../view/popularizationScience.vue')
            }
        ]
    }
]